import { render, staticRenderFns } from "./NearMatchResolveCardDirectMatch.vue?vue&type=template&id=523df542&scoped=true&"
import script from "./NearMatchResolveCardDirectMatch.vue?vue&type=script&lang=js&"
export * from "./NearMatchResolveCardDirectMatch.vue?vue&type=script&lang=js&"
import style0 from "./NearMatchResolveCardDirectMatch.vue?vue&type=style&index=0&id=523df542&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523df542",
  null
  
)

export default component.exports